module.exports = {
      id: "apple-usage",
      viewBox: "0 0 56 56",
      url: __webpack_public_path__ + "svg-sprite-c71831da97eff2ec188167649c252867.svg#apple",
      toString: function () {
        return this.url;
      }
    }